import { apiGet, apiPost, apiPut } from '@/api/http';

import type { City, Region } from '@/types/reference';

const apiUrl = import.meta.env.VITE_API_URL;

export const getRegions = () =>
  apiGet<{ id: string; name: string }[]>(`${apiUrl}regions/`);

export const createRegion = (name: string) =>
  apiPost<Region>(`${apiUrl}regions/`, { name });

export const getCityList = async (): Promise<City[]> => {
  const cities = await apiGet<City[]>(`${apiUrl}cities/`);

  const Remote = 'Remote';
  const Relocate1 = 'Relocate to NL from EU';
  const Relocate2 = 'Relocate to NL from outside EU';

  const RemoteCity = cities.find(({ name }) => name === Remote);
  const RelocateCity1 = cities.find(({ name }) => name === Relocate1);
  const RelocateCity2 = cities.find(({ name }) => name === Relocate2);

  const filtered = cities.filter(
    ({ name }) => name !== Remote && name !== Relocate1 && name !== Relocate2,
  );
  return [RemoteCity, RelocateCity1, RelocateCity2, ...filtered].filter(
    (city): city is City => city !== undefined,
  );
};

export const setRecruiterLocations = (locationIds: string[]) =>
  apiPut(`${apiUrl}recruiters/me/locations/`, {
    locations: locationIds,
  });
